import { queryFor } from "@visioni/a3s-client-api/app";
import { listSnapshotsEndpoint } from "../client-messages/snapshots";
import { listClipsEndpoint, countClipsByHourEndpoint } from "../client-messages/clips";
import { listLivestreamsEndpoint } from "../client-messages/livestreams";
import { listTimelapseFramesEndpoint, getTimelapseVideoEndpoint } from "../client-messages/timelapse";

export const snapshotsQuery = queryFor(listSnapshotsEndpoint);

export const clipsQuery = queryFor(listClipsEndpoint);

export const clipHourlyCountsQuery = queryFor(countClipsByHourEndpoint);

export const livestreamsQuery = queryFor(listLivestreamsEndpoint);

export const timelapseFramesQuery = queryFor(listTimelapseFramesEndpoint);

export const timelapseVideoStatusQuery = queryFor(getTimelapseVideoEndpoint);
